import type { Props } from '@travel/traveler-core/components/Swiper';
import SwiperCore from '@travel/traveler-core/components/Swiper';
import { EMPTY_ARRAY } from '@travel/traveler-core/constants';

function Swiper({ children = EMPTY_ARRAY, initialSlide = 0, ...props }: Props) {
  return <SwiperCore children={children} initialSlide={initialSlide} {...props} />;
}

export default Swiper;
